export default __webpack_public_path__ + "static/media/ckg-logo.cc5a419b.svg";